import { render, staticRenderFns } from "./ActiveMembers.vue?vue&type=template&id=6bed0a12"
import script from "./ActiveMembers.vue?vue&type=script&lang=js"
export * from "./ActiveMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports